import { useRouterState } from '@tanstack/react-router';
import { Building2, Target } from 'lucide-react';
import { useCrmAccess } from '@/lib/crm/use-crm-access';
import type { ToolOption } from './ToolSwitcher';

const WORKSPACE_TOOL: ToolOption = {
  id: 'workspace',
  label: 'Entiti',
  description: 'Entities, workers, compliance and documents',
  to: '/',
  icon: Building2,
};

const CRM_TOOL: ToolOption = {
  id: 'crm',
  label: 'CRM',
  description: 'Leads, opportunities and proposals',
  to: '/crm',
  icon: Target,
};

/** True when `pathname` is inside the CRM tool. */
export function isCrmPath(pathname: string): boolean {
  return pathname === '/crm' || pathname.startsWith('/crm/');
}

/** The tools this caller may open, and the one the current page belongs to. */
export function useAppTools(): { tools: ToolOption[]; currentId: string } {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { canOpenCrm } = useCrmAccess();
  return {
    tools: canOpenCrm ? [WORKSPACE_TOOL, CRM_TOOL] : [WORKSPACE_TOOL],
    currentId: isCrmPath(pathname) ? CRM_TOOL.id : WORKSPACE_TOOL.id,
  };
}
